import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import fileDownload from 'js-file-download';

export const loadPayments = createAsyncThunk(
  'payments/loadPayments',
  async ({ page = 1, searchValue = '', organization = null }, { rejectWithValue }) => {
    try {
      let url = `invoices/payments/?page=${page}&page_size=100`;
      if (searchValue) url += `&search=${searchValue}`;
      if (organization) url += `&organization=${organization}`;
      const response = await axios.get(url);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const downloadReceipt = createAsyncThunk(
  'payments/downloadReceipt',
  async ({ id, receiptNo }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/invoices/payments/${id}/receiptDownload/`, {}, {
        responseType: 'blob',
      });
      const filename = receiptNo ? `${receiptNo}.pdf` : `receipt-${id}.pdf`;
      fileDownload(response.data, filename);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const sendReceipt = createAsyncThunk(
  'payments/sendReceipt',
  async ({ id, to, cc, bcc, subject, template }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/invoices/payments/${id}/sendReceipt/`, {
        to,
        cc,
        bcc,
        subject,
        template,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const paymentsSlice = createSlice({
  name: 'payments',
  initialState: {
    payments: [],
    loading: false,
    error: null,
    receiptDownloading: false,
    receiptSending: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadPayments.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.payments = action.payload;
      })
      .addCase(loadPayments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Download Receipt
      .addCase(downloadReceipt.pending, (state) => {
        state.receiptDownloading = true;
      })
      .addCase(downloadReceipt.fulfilled, (state) => {
        state.receiptDownloading = false;
      })
      .addCase(downloadReceipt.rejected, (state, action) => {
        state.receiptDownloading = false;
        state.error = action.payload;
      })
      // Send Receipt
      .addCase(sendReceipt.pending, (state) => {
        state.receiptSending = true;
      })
      .addCase(sendReceipt.fulfilled, (state) => {
        state.receiptSending = false;
      })
      .addCase(sendReceipt.rejected, (state, action) => {
        state.receiptSending = false;
        state.error = action.payload;
      });
  },
});

export default paymentsSlice.reducer;
